import React, { FunctionComponent } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker as MuiDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useStyles, datePickerTheme } from './DatePicker.styles';

interface IProps {
  id: string;
  name: string;
  value: Date | null;
  customClass?: string;
  placeholder?: string;
  onChange?: (date: Date | null) => void;
  disabled?: boolean;
  errorMessage?: string;
  showIcon?: boolean;
}

const DatePicker: FunctionComponent<IProps> = ({
  id,
  name,
  value,
  onChange = () => {},
  placeholder = 'MM/DD/YYYY',
  customClass = '',
  disabled = false,
  errorMessage,
  showIcon = true,
}) => {
  const classes = useStyles();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={datePickerTheme}>
        <MuiDatePicker
          value={value}
          onChange={onChange}
          disabled={disabled}
          // renderInput={(params: TextFieldProps) => (
          //   <TextField
          //     {...params}
          //     id={id}
          //     name={name}
          //     placeholder={placeholder}
          //     fullWidth
          //     error={!!errorMessage}
          //     helperText={errorMessage}
          //     InputProps={{
          //       ...params.InputProps,
          //       disableUnderline: true,
          //       classes: {
          //         root: cx(classes.input, {
          //           [customClass]: !!customClass,
          //           [classes.error]: !!errorMessage,
          //         }),
          //       },
          //     }}
          //     InputLabelProps={{ shrink: true }}
          //     autoComplete="off"
          //   />
          // )}
        />
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default DatePicker;
